import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'
import { ConvertedComponentData, FsCatalog, TextInput } from '../../types'
import { TeaserBoxHomepageImageData } from './teaser-box-homepage/teaser-box-homepage-image.component.converter'

@Injectable({ providedIn: 'root' })
export class TeaserBoxesHomepageConverter extends CmsConverterService<TeaserBoxesHomepageData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      backgroundColor: formData.st_backgroundcolor?.value?.identifier ?? '',
      headline: formData.st_headline ?? defaultTextInput,
      items: formData.st_items ?? defaultTextInput,
      promotionTracking: formData.promotion_tracking?.value?.identifier ?? true
    }
  }
}

export const TEASER_BOXES_HOMEPAGE_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TeaserBoxesHomepageData>>('TeaserBoxesHomepageConverter')

export interface TeaserBoxesHomepageData extends ConvertedComponentData {
  items: FsCatalog<TeaserBoxHomepageImageData>;
  backgroundColor: string;
  headline: TextInput;
  promotionTracking: boolean;
}
